import _ from 'lodash';
import ah from '../utils/ajax-helper'; // 取得貨櫃中心列表

export var getAreaZones = function getAreaZones(contextRoot, noProgress, sort) {
  var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var limit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  return new Promise(function (resolve, reject) {
    var sortField = sort ? sort.field : 'id';
    var sortOrder = sort ? sort.desc ? 'desc' : 'asc' : 'asc';
    var requestParameters = {
      offset: offset,
      limit: limit,
      sort: sortField + ':' + sortOrder
    };
    ah.get("".concat(contextRoot, "/zone/list"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // 取得貨櫃中心列表-依經緯度範圍取得

export var getAreaZonesGeographic = function getAreaZonesGeographic(contextRoot, noProgress, latLngStart, latLngEnd) {
  return new Promise(function (resolve, reject) {
    var requestParameters = {
      longitude: "".concat(latLngStart.lng, ",").concat(latLngEnd.lng),
      latitude: "".concat(latLngStart.lat, ",").concat(latLngEnd.lat)
    };
    ah.get("".concat(contextRoot, "/zone/list/geographic"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // 取得港區查驗站列表

export var getAreaGates = function getAreaGates(contextRoot, noProgress) {
  var zoneId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var sort = arguments.length > 3 ? arguments[3] : undefined;
  var offset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var limit = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  var start = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
  return new Promise(function (resolve, reject) {
    var sortField = sort ? sort.field : 'defaultOrder';
    var sortOrder = sort ? sort.desc ? 'desc' : 'asc' : 'asc';
    var requestParameters = {
      'zone-id': zoneId,
      offset: offset,
      limit: limit,
      sort: sortField + ':' + sortOrder,
      start: start
    };
    ah.get("".concat(contextRoot, "/gate/list"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // 取得港區查驗站列表-依經緯度範圍取得

export var getAreaGatesGeographic = function getAreaGatesGeographic(contextRoot, noProgress, latLngStart, latLngEnd) {
  return new Promise(function (resolve, reject) {
    var requestParameters = {
      longitude: "".concat(latLngStart.lng, ",").concat(latLngEnd.lng),
      latitude: "".concat(latLngStart.lat, ",").concat(latLngEnd.lat)
    };
    ah.get("".concat(contextRoot, "/gate/list/geographic"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // 取得櫃場列表

export var getAreaTerminals = function getAreaTerminals(contextRoot, noProgress) {
  var zoneId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var sort = arguments.length > 3 ? arguments[3] : undefined;
  var offset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var limit = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  var keyword = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
  var onlyUser = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
  return new Promise(function (resolve, reject) {
    var sortField = sort ? sort.field : 'defaultOrder';
    var sortOrder = sort ? sort.desc ? 'desc' : 'asc' : 'asc';
    var requestParameters = {
      'zone-id': zoneId,
      offset: offset,
      limit: limit,
      sort: sortField + ':' + sortOrder,
      keyword: keyword,
      onlyUser: onlyUser
    };
    ah.get("".concat(contextRoot, "/terminal/list"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // 取得櫃場列表-依經緯度範圍取得

export var getAreaTerminalsGeographic = function getAreaTerminalsGeographic(contextRoot, noProgress, latLngStart, latLngEnd) {
  return new Promise(function (resolve, reject) {
    var requestParameters = {
      longitude: "".concat(latLngStart.lng, ",").concat(latLngEnd.lng),
      latitude: "".concat(latLngStart.lat, ",").concat(latLngEnd.lat)
    };
    ah.get("".concat(contextRoot, "/terminal/list/geographic"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // 取得櫃場列表 - 交領櫃分列

export var getAreaTerminalsDeliverTypeSeparated = function getAreaTerminalsDeliverTypeSeparated(contextRoot, noProgress) {
  var zoneId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var keyword = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var sort = arguments.length > 4 ? arguments[4] : undefined;
  var offset = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
  var limit = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
  return new Promise(function (resolve, reject) {
    var sortField = sort ? sort.field : 'updatedAt';
    var sortOrder = sort ? sort.desc ? 'desc' : 'asc' : 'desc';
    var requestParameters = {
      'zone-id': zoneId,
      keyword: keyword,
      offset: offset,
      limit: limit,
      sort: sortField + ':' + sortOrder
    };
    ah.get("".concat(contextRoot, "/terminal/deliver-type-separated/list"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; //　取得所有港口

export var getHarborListAll = function getHarborListAll(contextRoot, noProgress) {
  return new Promise(function (resolve, reject) {
    ah.get("".concat(contextRoot, "/harbor/list/all"), null, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // 取得櫃場關聯攝影機
// 設定櫃場關聯攝影機  /terminal/{terminalId}/cameras

export var setTerminalRelatedCameraAPI = function setTerminalRelatedCameraAPI(contextRoot, noProgress, terminalId, relatedCameras) {
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/terminal/").concat(terminalId, "/cameras"), JSON.stringify(relatedCameras), null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
};